// 月初现金余额管理
export default {
  interestBank: {
    search: {
      loanDateStart: '借款日期从',
      loanDateEnd: '借款日期到',
      refundDateStart: '还款日期从',
      refundDateEnd: '还款日期到',
    },
    column: {
      company: '公司',
      contractNo: '合同号',
      loanDate: '借款日期',
      loanAmount: '借款金额',
      refundDate: '还款日期',
      refundAmount: '还款金额',
      loanDays: '天数',
      interestRate: '利率',
      interestAmount: '利息',
      currencyCode: '币种',
      bankName: '对应银行',
      remark: '备注',
    },
    placeholder: {
      companyPlaceholder: '请选择公司',
      contractNoPlaceholder: '请输入合同号',
      loanDatePlaceholder: '请选择借款日期',
      loanAmountPlaceholder: '请输入借款金额',
      refundDatePlaceholder: '请选择还款日期',
      refundAmountPlaceholder: '请输入还款金额',
      loanDaysPlaceholder: '请输入天数',
      interestRatePlaceholder: '请输入利率',
      interestAmountPlaceholder: '请输入利息',
      currencyCodePlaceholder: '请选择币种',
      bankNamePlaceholder: '请选择对应银行',
      remarkPlaceholder: '请输入备注',
    },
    button: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
      select: '请选择一条数据操作，或直接点击行数据编辑',
    },
  },
};
